function init_teachergame(from_php){
    if(!from_php.girl_id){
        return false;
    }
    if(_ON_DEV){
        console.log(from_php);
    }
    var main=$(".place.teachergame");
    var gameTeacherObj;
    main.css({"background-color":"white",color:"black"});
    if(typeof from_php.girl_id=="undefined" || from_php.girl_id==0){
        return false;
    }
    var gameCanv=main.find("#girlGameJsCanvas");
    
    
    var semaphoreSuit= new mySemaphore();
    
    var girl_id=intval(from_php.girl_id);
    var gameInitObj=new afterInit();
    
    var timeIndexArr={
        "ajax":_moduleTimeHandler.getNewIndex(),
        "wrong":_moduleTimeHandler.getNewIndex(),
        "timeout":_moduleTimeHandler.getNewIndex(),
        "timeout_error":_moduleTimeHandler.getNewIndex()
    };

    var girl_name=$.takeGirlImage(girl_id);
    var gameCover=main.find("#gameCover");
    var gameCoverState=main.find(".stateJS"),gameCoverWin;
    var state_cur="";
    var gameLog=[];
    var secureStr=from_php.secure;
    var ajaxTimeHandler=_moduleTimeHandler.getNewIndex();
    
    function postAjax(to_send,refuse_response,on_end){
        if(semaphoreSuit.use()){
            var data_send={girl_id:girl_id,page:"teachergame"};
            data_send=$.extend(data_send,to_send);
            $.mypost('/ajax',data_send, function(res) {
                var data=handleAjaxRes(res),was_clear=0;
                if(typeof data!="undefined" && data){
                    if(intval(data.was_ended)>intval(from_php.was_ended)){
                    _mySound.playSound("girl_moan");
                        $.goToLocation("teacheranim/"+girl_id+"/1/");
                        return false;
                    }
                    from_php=$.extend(from_php,data);
                    var howlong=20;
                    if(state_cur=="game"){
                        howlong=1000;
                    }
                    _moduleTimeHandler.setOne(ajaxTimeHandler,function(){
                        gameTeacherObj.updateState({val:data.repeat_val,moves:data.repeat_moves});
                        if(data.repeat_val>0 && data.was_paid==0){
                            $.goToLocation("teachergame/"+girl_id+"/");
                        }
                        else{
                            updateState();
                        }

                        semaphoreSuit.clear();
                    },howlong);
                        
                }
                
            },"json");
        }
    }
    
    function updateState(){
        
        if(from_php.was_paid){
            showState("game");
        }
        else{
            if(from_php.repeat_val){
                showState("val_lose");
                //
                //always fail repeat if repeat_val>val_need*(0.2)
                
                /*
                 * repeat_val
                 * val_need
                 * was_error
                 * 
                 * 
                 */
                
                //can repeat, lose_val
            }
            else if(typeof from_php.res!="undefined"){
                if(from_php.game_conf.state.type=="coin"){
                    showState("coin_win");
                    /*
                     * res:
                     * coin_have
                     * coin_add
                     * coin_need
                     * try_count_have
                     * try_count_add
                     * 
                     */
                }
                else{
                    showState("val_win");
                    /*
                     * res:
                     * val_have
                     * val_need
                     * 
                     * 
                     * 
                     */
                }
            }
            else{
                if(from_php.try_count>0){
                    showState("init");
                }
                else{
                    showState("need_try");
                }
            }
        }
    }
    
    
    function init(){
        main.find(".butNextLevelStartJS").click(function(){
            _mySound.playSound("button_click");
            postAjax({start_game:1});
        });
        
        
        
        main.find(".buyGirlDateJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            $.payByPremium(premium_count,function(){
                postAjax({buy_date:1});
            });
        });
        main.find(".repeatMoveTriggerJS").click(function(){
            _mySound.playSound("button_click");
           var th=$(this),premium_count=intval(th.attr("data-need"));
           $.payByPremium(premium_count,function(){
                postAjax({buy_repeat:1});
            });
        });
        
        var gameCanvas=main.find("#girlGameJsCanvas");
        
        
        
        
        updateState();
    }
    
    
    var stateIndex={
        "game":[_moduleTimeHandler.getNewIndex()]
    };
    var stateFun={
        "coin_win":function(win){
            var i,bum,is_premium="",html="";
            for(i=0;i<from_php.res.coin_add_max;i++){
                if(i<from_php.res.coin_add){
                    if(i>=from_php.res.coin_add/2 && from_php.game_conf.bonus1){
                        is_premium=" premium";
                    }
                    html+="<div class='star have"+is_premium+"'></div>";
                }
                else{
                    html+="<div class='star'></div>";
                }
            }
            win.find(".starWrap").html(html);
            if(is_premium){
                win.find(".starWrap").addClass("premium");
            }
            
            var str="0"
            if(from_php.res.try_count_add>0){
                str="+"+from_php.res.try_count_add;
            }
            win.find(".putRes[data-type='try_count_add']").html(str);
        },
        "val_win":function(win){
            win.find(".putRes[data-type='val_have']").html(numberFormat(from_php.res.val_have,0,0));
            win.find(".putRes[data-type='val_need']").html(numberFormat(from_php.res.val_need,0,0));
        },
        "val_lose":function(win){
            win.find(".reasonJS").html(from_php.langs["fail"+from_php.was_error]);
            win.find(".putRes[data-type='repeat_val']").html(numberFormat(from_php.repeat_val,0,0));
            win.find(".putRes[data-type='val_need']").html(numberFormat(from_php.val_need,0,0));
            var repeat_type="premium";
            if(from_php.try_count>=from_php.conf_user.currency_repeat){
                repeat_type="currency";
            }
            win.find(".priceCellJS").addClass("hide").filter("[data-price='"+repeat_type+"']").removeClass("hide");
            win.find(".butRepeatJS").off("click.repeat").on("click.repeat",function(){
                var th=$(this),repeat_type=0,repeat_names={"currency":1,"premium":2};
                var repeat_name=th.attr("data-price");
                if(typeof repeat_names[repeat_name]!="undefined"){
                    repeat_type=repeat_names[repeat_name];
                }
                postAjax({buy_repeat:1,repeat_type:repeat_type});
            });
        },
        "init":function(win){
            
            
        },
        "need_try":function(win){
            postAjax({looseGame:1});
        },
        "game":function(win){
             gameCover.addClass("hide");
             main.find(".hideOnGameJS").addClass("hide");
             main.find(".showOnGameJS").removeClass("hide");
             
             
            gameInitObj.addFun(function(){
                gameCanv.one("game_change",function(){
                   var state=gameTeacherObj.takeState(); 
                   postAjax({
                       game_conf:(Base64.encode(secureStr)),
                       val:state.val,moves:state.moves,
                       was_error:state.was_error
                   });
                   
                });
                gameTeacherObj.start();
            });
            
            
             
//             from_php.game_conf
             
        }
    };
    function showState(state){
        main.find(".putGameJs[data-type='try']").html(from_php.try_count);
        main.find(".arrSetCountJS").attr("data-count",from_php.try_count);
        _timerManager.addTimer(".place.gameninja .timerKeyWaitJS",from_php.try_time,1);
        _moduleTimeHandler.clear(timeIndexArr.timeout);
        
        if(state!="game"){
            main.find(".hideOnGameJS").removeClass("hide");
            main.find(".showOnGameJS").addClass("hide");
            gameCover.removeClass("hide");
        }
        
        
        
        
        gameCoverWin=gameCoverState.addClass("hide").filter("[data-state='"+state+"']").removeClass("hide");
        if(typeof stateFun[state]=="undefined"){
            alert(state+"!");
        }
        var win=main.find(".stateJS[data-state='"+state+"']");
        stateFun[state](win);
        
        main.find(".textfill").textfill();
        state_cur=state;
    }
    
    
    
    init();

//    showState("game");

    gameCanv.one("gameReady",function(){
        main.find(".preloadJS").addClass("hide");
        main.find(".preloadAfterJS").removeClass("hide");
        gameInitObj.load();
    });
    
    from_php.game_conf.girl_id=from_php.girl_id;
    gameTeacherObj=new gameTeacher(gameCanv,from_php.game_conf);
    
    
   
      
    var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner,#ic_premium");
    toHide.css("bottom","-100px");
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });
      
}